import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Notes from '../../components/Notes';
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments,updateFaqsNotesDocuments,deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectNotes } from '../../store/selectors/faqsNotesDocuments';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search';
import { fetchPropertyCounts } from '../../store/actions/properties';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';

class PropertyNotes extends Component {
  componentDidMount(){
    const { onFetchFaqsNotesDocumentss, property } = this.props;
    this.props.clearSearch()
    onFetchFaqsNotesDocumentss(property.propertyId);

  }

  onSaveNote = async (note) => {    
    
    const {  onSaveFaqsNotesDocuments, onUpdateFaqsNotesDocuments, onFetchPropertyCounts, user  } = this.props;

    let utcTime = ''
    if( note.appointment){

    
   
    let date = new Date(note.appointment.date);
    let time = new Date(note.appointment.time)
    let hours = time.getHours();
    let minutes =time.getMinutes();
    date.setHours(hours);
    date.setMinutes(minutes)

    // utcTime = date.toUTCString()
      utcTime = date
    }

    if(note.id){
      let data = {
        ItemId: this.props.property.id,
        "id": note.id,
        Name: 'NOTES',
        ItemType: 'Property',
        Type: 'NOTES',
        "Data": JSON.stringify(note).toString(),
        "UserId": this.props.user.id,
        'visibilityType':note.visibilityType,
        noteVisibleToHomeownerOccupantRealtor:note.noteVisibleToHomeownerOccupantRealtor,
      }

      if(note.appointment){
        data.ReminderDate = utcTime
      }
 
      onUpdateFaqsNotesDocuments(data)
    } else {
      note = { ...note,'author':{
        "id": this.props.user.id,
        "firstName": this.props.user.firstname,
        "lastName": this.props.user.lastname
      },'createdAt': new Date()}

      let data = {
        ItemId: this.props.property.id,
        Name: 'NOTES',
        ItemType: 'Property',
        Type: 'NOTES',
        Data: JSON.stringify(note).toString(),
        UserId: this.props.user.id,
        'visibilityType':note.visibilityType,
        noteVisibleToHomeownerOccupantRealtor:note.noteVisibleToHomeownerOccupantRealtor,
      }

      if(note.appointment){
        data.ReminderDate = utcTime
      }

     await onSaveFaqsNotesDocuments(data)
     onFetchPropertyCounts(this.props.property.propertyId, user.id, user.roles[0].role.name)

    }
  }
  onDeleteFaqsNotesDocuments = async (notes) => {
    const { user, property, onFetchPropertyCounts, onDeleteFaqsNotesDocuments } = this.props;
    notes.Type = 'NOTES';
    notes.ItemType = 'Property';
    await onDeleteFaqsNotesDocuments(notes)
    onFetchPropertyCounts(property.propertyId, user.id, user.roles[0].role.name)
  }
  render() {
    let { notes, property, onDeleteFaqsNotesDocuments, setSearch, user, loader } = this.props;
    return (
      loader ? <Loader /> :
      <Notes
        breadcrumb={property.name}
        from={'properties'}
        notes={notes}
        onSaveNote={this.onSaveNote}
        onDeleteNote={ notes => this.onDeleteFaqsNotesDocuments(notes)}
        onSearch={e => setSearch({ notes: e.target.value.trim() })}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  
  let user = selectAuthenticatedUser(state);
  return {
    notes: selectNotes(state),
    user,
    loader: selectPRLoader(state),
  }
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocumentss: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments: saveFaqsNotesDocuments,
  onUpdateFaqsNotesDocuments: updateFaqsNotesDocuments,
  onDeleteFaqsNotesDocuments: deleteFaqsNotesDocuments,
  setSearch,
  clearSearch,
  onFetchPropertyCounts: fetchPropertyCounts,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PropertyNotes);
